import type { ReactNode } from 'react';
import StickyBox from 'react-sticky-box';

import { Box } from '#/components/Box/Box';
import { colors, gutterWidth } from '#/theme/theme';

function Container({
  children,
  hasSidebar,
}: {
  children: ReactNode;
  hasSidebar: boolean;
}) {
  if (hasSidebar) return <Box display="flex">{children}</Box>;

  // oxlint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

type Props = {
  sidebar?: ReactNode;
  children: ReactNode;
};

export function MultiStepFormLayout({ sidebar, children }: Props) {
  const hasSidebar = Boolean(sidebar);
  return (
    <Container hasSidebar={hasSidebar}>
      <Box
        maxWidth={sidebar ? 856 : 'none'}
        height="100%"
        flex="1 1 auto"
        m="0 auto"
        // @ts-expect-error TS(2322): Type 'false | (number | null)[]' is not assignable... Remove this comment to see the full error message
        px={
          hasSidebar && [
            gutterWidth / 2,
            null,
            null,
            gutterWidth,
            gutterWidth * 2,
          ]
        }
      >
        <Box
          minHeight={hasSidebar ? 'calc(100vh - 150px)' : undefined}
          height="100%"
        >
          {children}
        </Box>
      </Box>

      {sidebar && (
        <Box
          display={['none', null, null, 'block']}
          width={1 / 3}
          maxWidth={572}
          flex="0 0 auto"
        >
          <StickyBox>
            <Box
              position="sticky"
              right={0}
              top={0}
              maxWidth={572}
              minHeight="100vh"
              display="flex"
              alignItems="center"
              bg={colors.backgroundGrey}
            >
              {sidebar}
            </Box>
          </StickyBox>
        </Box>
      )}
    </Container>
  );
}
